<template>
    <page title="resetPasswordTitle">
        <template #pageContainer>
            <form v-if="!isPasswordReseted" onsubmit="return false;" >
				<v-row><v-col>
				<c-input
					v-model="password"
					type="password"
					labelWidth="15%"
					:title="$t('text.password')"
					:error="errors.password"
					@validate="validatePassword"
					:disabled="loading">
				</c-input>
				</v-col></v-row>
				<v-row><v-col>
				<c-input
					v-model="confirmPassword"
					type="password"
					labelWidth="15%"
					:title="$t('text.confirmPassword')"
					:error="errors.confirmPassword"
					@validate="validateConfirmPassword"
					:disabled="loading"
					@keyup.enter.native="resetPassword">
				</c-input>
				</v-col></v-row>

				<v-row><v-col>
					<c-button
						:disabled="loading || !validateForm()"
						@click="resetPassword"
						type="important"
						:label="$t(`text.resetPasswordButton`)"
						class="mr-2">
					</c-button>
				</v-col></v-row>
            </form>

            <v-alert v-else type="success">
                {{ $t(`text.resetPasswordSuccess`) }}
                <nav-item :to="{name: 'login'}" title="login"></nav-item>
            </v-alert>
            <spinner :loading="loading"></spinner>
        </template>
    </page>
</template>

<script>
import { mapActions } from 'vuex';

import authActions from '../store/actions/auth';
import namespace from '../store/namespace';

import Page from '../general/Page.vue';
import NavItem from '../navigation/Item.vue';
import Spinner from '../general/Spinner.vue';

import CInput from '../globalComponents/CInput.vue';
import CButton from '../globalComponents/CButton.vue';

import modelState from '../mixins/modelState';
import rules from '../globalComponents/mixins/rules';

export default {
	name: 'ResetPassword',
	mixins: [modelState, rules],
	components: {
		CButton,
		CInput,
		Page,
		NavItem,
		Spinner,
	},
	data() {
		return {
			userId: this.$route.query.userId,
			code: this.$route.query.code,
			password: '',
			confirmPassword: '',
			confirmed: false,
			loading: false,
			errors: {
				password: {},
				confirmPassword: {},
			},
		};
	},
	computed: {
		isPasswordReseted() {
			return this.confirmed;
		},
	},
	methods: {
		...mapActions(namespace.AUTH, [authActions.RESET_PASSWORD]),
		async resetPassword() {
			this.loading = true;

			if (this.validateForm()) {
				const resetPassword = {
					password: this.password,
					confirmPassword: this.confirmPassword,
					code: this.code,
					userId: this.userId,
				};

				try {
					this.modelState = {};
					await this.RESET_PASSWORD(resetPassword);

					this.confirmed = true;
				} catch (e) {
					if (e.response.status === 422) {
						this.modelState = e.response.data;
						if (this.modelError()) {
							throw new Error(this.modelError());
						}
					}

					throw e;
				} finally {
					this.loading = false;
				}
			}
			this.loading = false;
		},
		apiErrors(propName) {
			const apiErrors = this.validateProperty(propName);

			if (apiErrors.length > 0) return { show: true, message: apiErrors };

			return {};
		},
		validatePassword() {
			this.errors.password = {};
			if (this.isEmpty(this.password)) this.errors.password = { show: true, message: this.$i18n.t('text.errorPasswordRequired') };
			else this.errors.password = this.apiErrors('Password');
			this.validateConfirmPassword();
		},
		validateConfirmPassword() {
			this.errors.confirmPassword = {};
			if (this.isEmpty(this.confirmPassword)) this.errors.confirmPassword = { show: true, message: this.$i18n.t('text.errorConfirmPasswordRequired') };
			if (!this.isSame(this.confirmPassword, this.password)) this.errors.confirmPassword = { show: true, message: this.$i18n.t('text.errorConfirmPasswordWrong') };
			else this.errors.confirmPassword = this.apiErrors('ConfirmPassword');
		},
		validateForm() {
			const val = Object.keys(this.errors);

			const ret = val.every((p) => {
				if (this.errors[p].show === true) {
					return false;
				}
				return true;
			});

			return ret;
		},
	},
};
</script>
